<template>
  <ul class="form-item-list">
    <li><h3><b>[계약자 기준]</b> 평균 월소득을 입력해주세요</h3></li>
    <li>
      <div class="label">{{ formData.월소득.label }}</div>
      <el-input
        type="text"
        v-model="formData.월소득.value"
        :placeholder="formData.월소득.placeholder"
      >
        <span slot="suffix">만원</span>
      </el-input>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Info',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
    }
  },
  watch: {
    'formData.월소득.value': function (n) {
      this.update('월소득', n);
    },
  },
  methods: {
    update(type, value) {
      if (value !== '') {
        this.$emit('update', { type, value });
      }
    }
  }
}
</script>

<style lang="scss">
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .el-input {
    height: 54px;

    & ::-webkit-input-placeholder { text-align:right; }
    & input:-moz-placeholder { text-align:right; }

    .el-input__inner {
      height: 54px;
      border-radius: 0;
    }

    .el-input__suffix-inner {
      line-height: 54px;
      color: #000;
    }
  }
}
</style>